/**
 * Controls the animation state of tickertape carousels.
 *
 * @param {NodeList|Array} tickertapeWrappers - Collection of DOM elements containing tickertape carousels
 * @returns {void}
 */
const tickertape = tickertapeWrappers => {
  if (!tickertapeWrappers) return;

  tickertapeWrappers.forEach( wrapper => {
    const pauseButton = wrapper.querySelector( '.tickertape__pause-button' );
    const tickertapeWrapper = wrapper.querySelector( '.tickertape__wrap' );

    if (!pauseButton || !tickertapeWrapper) return;

    pauseButton.addEventListener( 'click', () => {
      const isPaused = pauseButton.getAttribute( 'aria-pressed' ) === 'true';

      tickertapeWrapper.style.animationPlayState = isPaused ? 'running' : 'paused';
      pauseButton.setAttribute( 'aria-pressed', !isPaused );
      pauseButton.setAttribute(
        'aria-label',
        isPaused ? bsl_variables.play : bsl_variables.pause
      );
    } );
  } );
};

tickertape( document.querySelectorAll( '.tickertape__list' ) );
